import React from 'react'
import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineCancelIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="m21.77 11.36-5-6A1.0004 1.0004 0 0 0 16 5H5a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h11a1 1 0 0 0 .77-.36l5-6a.9997.9997 0 0 0 0-1.28ZM15.53 17H5a1.0002 1.0002 0 0 1-1-1V8a1 1 0 0 1 1-1h10.53l4.17 5-4.17 5Zm-2.82-7.71a1.001 1.001 0 0 0-.71-.2958 1.0003 1.0003 0 0 0-.71.2958L10 10.59l-1.29-1.3a1.0041 1.0041 0 0 0-1.42 1.42L8.59 12l-1.3 1.29a1.001 1.001 0 0 0-.2958.71 1.0003 1.0003 0 0 0 .2958.71 1.001 1.001 0 0 0 .71.2958.9994.9994 0 0 0 .71-.2958l1.29-1.3 1.29 1.3a.9997.9997 0 0 0 1.42 0 .9997.9997 0 0 0 0-1.42L11.41 12l1.3-1.29a.9997.9997 0 0 0 0-1.42Z"/>
  </SvgIcon>
}

export default LineCancelIcon
